import { ORDINARY_DATA } from './ordinary-data.js';
/** The oo1 order and content are frozen once v2 challenges are published. */
export const ORDINARY_PACK_SETS = ORDINARY_DATA.questions.map(({ drawings, ...set }) => ({
    ...set,
    source: 'pack',
    render(features) {
        const index = set.sentences.findIndex((s) => set.axes.every((axis) => s.features[axis.name] === features[axis.name]));
        if (index < 0)
            throw new Error(`Unknown features for ${set.id}`);
        return drawings[index].map((id) => ORDINARY_DATA.strokes[id]);
    },
}));
//# sourceMappingURL=ordinary-pack.js.map